<template>

  <div class="mod-counting">

    <el-form :inline="true" :model="dataForm" @keyup.enter.native="pageIndex = 1; getDataList()">

      <el-form-item label="盘点单号">

        <el-input v-model="dataForm.code" size="small" clearable style="width:150px" />

      </el-form-item>

      <el-form-item label="状态">

        <el-select v-model="dataForm.status" size="small" clearable placeholder="全部" style="width:120px">

          <el-option label="未审" value="0" />

          <el-option label="已审" value="2" />

        </el-select>

      </el-form-item>

      <el-form-item>

        <el-button v-if="isAuth('inventory:counting:list')" type="primary" size="small" @click="pageIndex = 1; getDataList()">查询</el-button>

        <el-button size="small" @click="resetQuery">重置</el-button>

      </el-form-item>

      <el-form-item>

        <el-button v-if="isAuth('inventory:counting:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>

      </el-form-item>

    </el-form>



    <el-table

      :data="dataList"

      border

      v-loading="dataListLoading"

      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"

      @row-dblclick="row => open(row.countingId, true)"

    >

      <el-table-column type="index" label="序号" header-align="center" align="center" width="60" />

      <el-table-column prop="countingCode" label="盘点单号" header-align="center" align="left" min-width="150">

        <template slot-scope="scope">

          <a v-if="isAuth('inventory:counting:info')" class="code-link" @click="addOrUpdateHandle(scope.row.countingId, true)">{{ scope.row.countingCode }}</a>

          <span v-else>{{ scope.row.countingCode }}</span>

        </template>

      </el-table-column>

      <el-table-column prop="countingDate" label="日期" header-align="center" align="center" width="120" />

      <el-table-column prop="approveStatus" label="状态" header-align="center" align="center" width="90">

        <template slot-scope="scope">

          <el-tag :type="statusTagType(scope.row)" size="small">{{ statusText(scope.row) }}</el-tag>

        </template>

      </el-table-column>

    </el-table>



    <el-pagination

      @size-change="val => { pageSize = val; pageIndex = 1; getDataList() }"

      @current-change="val => { pageIndex = val; getDataList() }"

      :current-page="pageIndex"

      :page-sizes="[20, 50, 100]"

      :page-size="pageSize"

      :total="totalPage"

      layout="total, sizes, prev, pager, next, jumper"

    />



    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" />

  </div>

</template>



<script>

import AddOrUpdate from './counting-add-or-update'

import request from '../../api/request'

import { fetchPerms } from '../../api/auth'

import { workflowStatusText, workflowStatusTagType } from '../../utils/workflow'



export default {

  name: 'Counting',

  components: { AddOrUpdate },

  data() {

    return {

      dataForm: { code: '', status: '' },

      dataList: [],

      pageIndex: 1,

      pageSize: 20,

      totalPage: 0,

      dataListLoading: false,

      addOrUpdateVisible: false,

      permCodes: []

    }

  },

  created() {

    this.loadPerms()

    this.getDataList()

  },

  activated() {

    this.getDataList()

  },

  methods: {

    isAuth(perm) {

      const user = this.$store.state.user || {}

      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []

      const role = String(user.roleCode || '')

      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true

      return this.permCodes.indexOf(perm) >= 0

    },

    loadPerms() {

      fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})

    },

    statusText(row) {

      return workflowStatusText(row.workflowStatus, row.approveStatus)

    },

    statusTagType(row) {

      return workflowStatusTagType(row.workflowStatus, row.approveStatus)

    },

    resetQuery() {

      this.dataForm = { code: '', status: '' }

      this.pageIndex = 1

      this.getDataList()

    },

    getDataList() {

      this.dataListLoading = true

      request.get('/inventory/counting/page', {

        params: {

          code: this.dataForm.code,

          status: this.dataForm.status,

          currentPage: this.pageIndex,

          pageSize: this.pageSize

        }

      }).then(res => {

        const body = res.data || {}

        this.dataList = body.list || []

        this.totalPage = body.totalCount || 0

      }).catch(() => {}).finally(() => { this.dataListLoading = false })

    },

    addOrUpdateHandle(id, readonly) {

      this.addOrUpdateVisible = true

      this.$nextTick(() => {

        this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id, readonly)

      })

    },

    open(id, readonly) {

      this.addOrUpdateHandle(id, !!readonly)

    }

  }

}

</script>



<style scoped>

.code-link { color: #348adb; cursor: pointer; }

</style>


